import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { breakpoint } from '@zocdoc/components/src/grid';
import { FontFamily } from '@zocdoc/components/src/typography';

const List = styled.ul`
    display: inline;

    &:after {
        content: ' ';
    }
`;

const Item = styled.li`
    display: inline;
    ${breakpoint.medium} {
        font: 18px/24px ${FontFamily.KievitSlabBook};
    }

    &:after {
        content: ', ';
    }

    &:last-child:after {
        content: '...';
    }
`;

const InNetworkInsurancePreview = ({ inNetworkInsurance }) => {
    const carriers = inNetworkInsurance.slice(0, 3).map(carrier => (
        <Item key={carrier.carrierId}>
            {carrier.carrierName}
        </Item>
    ));
    return (
        <List>
            {carriers}
        </List>
    );
};

InNetworkInsurancePreview.propTypes = {
    inNetworkInsurance: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default InNetworkInsurancePreview;
